<template>
  <div class="sucess">
    <div class="container">
      <img src="../../../assets/images/home/success.png" alt="">
      <p>支付成功</p>
      <button @click="toHome">回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toHome() {
      location.href = '/'
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.sucess{
  .container{
    padding: 110px 0;
    text-align: center;
    img{
      margin-bottom: 23px;
    }
    p{
      font-size: 24px;
      margin-bottom: 20px;
    }
    button{
      width: 70px;
      height: 34px;
      border:1px solid #999;
      background: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Success.vue